import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../index";
import * as urlService from "../view/urlService";

export const useMlDetectionTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onDetectionDateClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('date')
        })
    }
    
    const onIPClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('ip')
        })
    }

    const onUserClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('usr')
        })
    }

    const onDetailsClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('note')
        })
    }

    const onResultClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('detectionResults')
        })
    }


    return {
        hardReload, onDetectionDateClick, onIPClick, onUserClick,onDetailsClick,onResultClick
    }
}
